import React from "react";

import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";

import GameTraverse from "../Game/Traverse";

import LeaderboardAllGames from "./AllGames";
import LeaderboardRecentGames from "./RecentGames";
import LeaderboardPlayerGames from "./PlayerGames";
import useLocalStorage from "../../services/useLocalStorage";
import { PLAYER_KEY } from "../../types/GameTypes";

import "./Leaderboard.scss";

function Leaderboard() {
  const [player] = useLocalStorage(PLAYER_KEY, "");

  return (
    <div className="leaderboard">
      <header>
        <h1>Leaderboard</h1>
      </header>

      <Tabs>
        <TabList>
          <Tab>Recent Games</Tab>
          <Tab disabled={!player}>Your Games</Tab>
          <Tab>Best Scores</Tab>
        </TabList>

        <TabPanel>
          <LeaderboardRecentGames />
        </TabPanel>

        <TabPanel>
          <LeaderboardPlayerGames />
        </TabPanel>

        <TabPanel>
          <LeaderboardAllGames />
        </TabPanel>
      </Tabs>

      <GameTraverse />
    </div>
  );
}

export default Leaderboard;
